// TODO: Put this object in themes pallete, when we will support different themes
export const customColors = {
  lightBlue: '#ebf2fc'
}
